<template>
    <v-tabs 
        v-model="localActiveTab" 
        background-color="transparent" 
        class="tabs"
        height="100%"
        slider-color="#DC0028"
        v-if="tabs"
    >
      <v-tab
        
      v-for="tab in tabs" :key="tab">
        {{ tab }}
      </v-tab>
    </v-tabs>
  </template>
  
  <script lang="ts">
  import { defineComponent } from 'vue';
  import store from '@/store';

  export default defineComponent({
    name: 'InformationSelectMenu',  
    props: {
      activeTab: {
        type: Number,
        required: true
      },
      tabs: {
        type: Array,
        required: true
      }
    },

    computed: {
      localActiveTab: {
        get() {
          // 
          return this.activeTab;
        },
        set(value:any) {

          const modes =[
            "risk",
            "keyFigures",
            "esg",
            "industry",
          ]
          store.dispatch("stateStoreData/setMenuMode", modes[value])
          
          this.$emit('update:activeTab', value);
        }
      },
      menuMode: {
        get() {
          return store.getters['stateStoreData/menuMode']
        },
        set(value: any) {
          store.dispatch('stateStoreData/setMenuMode', value)
        }
      }
    },
    unmounted() {
      this.localActiveTab = 0;
      store.dispatch('stateStoreData/setMenuMode', 'risk')
    },
    watch: {
      menuMode: {
        immediate: true,
        deep: true,
        handler(val) {
          // This now hides certain items, so we need to update the active tab not based on a literal value, but on the index of the tab
        //   switch (val) {
        //     case "risk":
        //       this.localActiveTab = 0;
        //       break;
        //     case "keyFigures":
        //       this.localActiveTab = 1;
        //       break;
        //     case "esg":
        //       this.localActiveTab = 2;
        //       break;
        //     case "industry":
        //       this.localActiveTab = 3;
        //       break;
        //     default:
        //       break;
        //   }

        // normalize tab names
        switch (val) {
          case "risk":
            val = "Country Risk";
            break;
          case "keyFigures":
            val = "Key Figures";
            break;
          case "esg":
            val = "ESG";
            break;
          case "industry":
            val = "Industry Performance";
            break;
          default:
            break;
        }

        for (let i = 0; i < this.tabs.length; i++) {
          console.log('comparin ',this.tabs[i],val)
          if (this.tabs[i] === val) {
            this.localActiveTab = i;
            break;
          }
        }
      }
    }
    }
  });
  </script>
  
  <style>
.tabs .v-btn__content{
    font-size: 13px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: -0.25px !important;
    font-family: 'GCO Sans', sans-serif;
    text-transform: capitalize !important;
    letter-spacing: 0.2px;
    color: #333;
}
</style>